<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos del decisor (representante)" title-color="dark" collapseAction >
      <div v-if="empresa">
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>DNI/CIF</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="decisor.dni" disabled/>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Cargo</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="operacionPersonaDecisor.cargo" disabled/>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Nombre</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="decisor.nombre" disabled/>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Apellidos</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="decisor.apellidos" disabled/>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Móvil de contacto</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="operacionPersonaDecisor.telefono" disabled/>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>E-mail</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="operacionPersonaDecisor.email" disabled/>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vs-alert color="danger" icon-pack="feather" icon="icon-info">
          <span>El cliente no es una empresa, por lo que no existe decisor.</span>
        </vs-alert>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Volver</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

export default {
  name: 'OperacionesEditDecisor',
  components: {},
  data () {
    return {
      operacion: {},
      operacionPersonaDecisor: {},
      decisor: {},
      decisorId: null,
      decisorCargo: null,
      decisorTelefono: null,
      decisorEmail: null,
      decisorIgualCliente: null,
      empresa: null
    }
  },
  computed: {},
  methods: {
    reset_data () {
      this.$router.push({name: 'operaciones'})
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))

    // Para mostrar ou ocultar a pantalla de decisor dependendo de si é unha empresa ou non
    this.operacion.tipoCliente === 'EMPRESA' ? this.empresa = true : this.empresa = false
    
    // Si existe 'decisor' na operación...
    if (this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR') !== undefined) {
      this.operacionPersonaDecisor = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR')))
      this.decisor = JSON.parse(JSON.stringify(this.operacionPersonaDecisor.persona))
      this.decisorId = this.operacionPersonaDecisor.persona.id
      this.decisorCargo = this.operacionPersonaDecisor.cargo
      this.decisorTelefono = this.operacionPersonaDecisor.telefono
      this.decisorEmail = this.operacionPersonaDecisor.email
    }
  }
}
</script>